import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PatientCategoryTable } from '../../patientCategory';
import { UnitTable } from '../../unit';
import { useScenarioSimulateMutation } from '../../../network/mutations';
import { Toolbar } from '../../common';

import HeaderCard from './HeaderCard';

function ReviewStep({ onBack, onNext }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { scenarioId } = useParams();

  const {
    mutate,
    isPending: isMutationPending,
    isSuccess: isMutationSuccess,
  } = useScenarioSimulateMutation();

  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const onConfirm = () => mutate({ scenarioId });

  useEffect(() => {
    // TODO: show mutation error
    if (!isMutationPending && isMutationSuccess) {
      onClose();
      navigate(`../scenarios/${scenarioId}`);
    }
  }, [isMutationPending, isMutationSuccess]);

  return (
    <>
      <Stack spacing={2} sx={{ flex: 1 }}>
        <HeaderCard title={t('pages.scenarios.configure.review.title')}>
          <Stack gap={2}>
            <Typography>
              {t('pages.scenarios.configure.review.subheader')}
            </Typography>
          </Stack>
        </HeaderCard>
        <Stack spacing={2}>
          <Card>
            <CardContent>
              <Stack spacing={2}>
                <Typography
                  variant="h5"
                  component="span"
                  sx={{ color: 'primary.main' }}
                >
                  Units
                </Typography>
                <UnitTable scenarioId={scenarioId} />
              </Stack>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Stack spacing={2}>
                <Typography
                  variant="h5"
                  component="span"
                  sx={{ color: 'primary.main' }}
                >
                  Patient Categories
                </Typography>
                <PatientCategoryTable scenarioId={scenarioId} />
              </Stack>
            </CardContent>
          </Card>
        </Stack>
        <Toolbar>
          <Button onClick={onBack}>{t('common.back')}</Button>
          <Button onClick={onNext} disabled>
            {t('common.next')}
          </Button>
          <Box sx={{ ml: 'auto' }}>
            <Button
              variant="contained"
              startIcon={<FontAwesomeIcon icon="play" />}
              onClick={() => setOpen(true)}
            >
              {t('pages.scenarios.configure.review.run')}
            </Button>
          </Box>
        </Toolbar>
      </Stack>
      <Dialog open={open}>
        <DialogTitle sx={{ color: 'primary.main' }}>
          {t('pages.scenarios.configure.review.confirm.title')}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {t('pages.scenarios.configure.review.confirm.message')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button disabled={isMutationPending} onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button
            variant="contained"
            startIcon={<FontAwesomeIcon icon="play" />}
            loading={isMutationPending}
            loadingPosition="start"
            onClick={onConfirm}
          >
            {t('pages.scenarios.configure.review.run')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ReviewStep;
